import React from "react";

export default function EmptyState({ title, body, action, icon }) {
  return (
    <div className="flex flex-col items-center text-center py-12 px-4">
      <div className="h-20 w-20 rounded-3xl bg-secondary border border-border flex items-center justify-center mb-4 text-4xl">
        {icon || "🎯"}
      </div>
      <div className="font-heading font-bold text-lg">{title}</div>
      {body && <div className="text-sm text-muted-foreground mt-1 max-w-xs">{body}</div>}
      {action}
    </div>
  );
}
